import React, { useState } from "react";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
import { axiosInstance } from "../../../utils";


export default function Iletisim() {
  const [kvkk, setKvkk] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [form, setForm] = useState<any>({
    name: "",
    surname: "",
    email: "",
    phone: "",
    message: ""
  });
  

  const handleSubmit = async () => {
    try{
      if(!kvkk){
        alert("Devam etmek için KVKK metnini kabul etmeniz gerekmektedir.");
        return;
      }

      const response = await axiosInstance.post("/contact/create", form);

      if(response.status === 201)
        alert("Form başarıyla gönderilmiştir.");

    }
    catch(e){
      console.log(e);
      alert("Form gönderilirken bir hata oluştu.");
    }
  }
  return (
    <div className="container-fluid animate pageWrapper">
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}

        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>İLETİŞİM</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="#">İLETİŞİM</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}

        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row start-md center-xs">
              <div className="col-lg-4 col-md-4 col-xs-12 textRow">
                <h2 className="title">İLETİŞİM</h2>
                <span className="textCapsule">
                  <p>
                    {/* Kozyatağı, Saniye Ermutlu Sokak
                    <br />
                    No:12-1 Çolakoğlu Plaza Kat:4
                    <br />
                    Kadıköy/İSTANBUL
                    <br />
                    <br /> */}
                    <b>Telefon :</b>{" "}
                    <a href="tel:+908502198559">0850 219 8559</a>
                    <br />
                    <b>e-Mail : </b>
                    <a href="mailto:info@kit-tak.com">info@kit-tak.com</a>
                  </p>
                </span>
              </div>
              <div className="col-lg-8 col-md-8 col-xs-12 contact">
                <h2 className="title wide">
                  <b>BİZE ULAŞIN</b>
                </h2>
                <div className="forms">
                  <div id="form-post-contact">
                    <input type="hidden" name="formtype" value="contact" />

                    <ul className="row">
                      <li className="col-sm-6 col-xs-12">
                        <input
                          type="text"
                          name="Name"
                          placeholder="İsminiz"
                          value={form.name}
                          onChange={(e) =>
                            setForm((prev: any) => ({
                              ...prev,
                              name: e.target.value,
                            }))
                          }
                          required
                        />
                      </li>
                      <li className="col-sm-6 col-xs-12">
                        <input
                          type="text"
                          name="Surname"
                          placeholder="Soyadınız"
                          value={form.surname}
                          onChange={(e) =>
                            setForm((prev: any) => ({
                              ...prev,
                              surname: e.target.value,
                            }))
                          }
                          required
                        />
                      </li>
                      <li className="col-sm-6 col-xs-12">
                        <input
                          value={form.phone}
                          onChange={(e) =>
                            setForm((prev: any) => ({
                              ...prev,
                              phone: e.target.value,
                            }))
                          }
                          type="text"
                          name="Telephone"
                          placeholder="Telefonunuz"
                          required
                        />
                      </li>
                      <li className="col-sm-6 col-xs-12">
                        <input
                          value={form.email}
                          onChange={(e) =>
                            setForm((prev: any) => ({
                              ...prev,
                              email: e.target.value,
                            }))
                          }
                          type="text"
                          name="Email"
                          placeholder="E-posta Adresiniz"
                          required
                        />
                      </li>
                      <li className="col-xs-12">
                        <textarea
                          value={form.message}
                          onChange={(e) =>
                            setForm((prev: any) => ({
                              ...prev,
                              message: e.target.value,
                            }))
                          }
                          name="Message"
                          placeholder="Mesajınız"
                        ></textarea>
                      </li>
                      <li className="col-xs-12"></li>

                      {/* <!--<li className="col-xs-12 start-xs onay">
    <label className="checkbox">
        <input type="checkbox" className="onay" id="IsRead" name="IsRead" value="Hayır" />
        <span className="Text"><a href="#" target="_blank">Gizlilik Sözleşmesini</a> Okudum Kabul Ediyorum.</span>
    </label>
</li>--> */}
                      <li className="col-xs-12 start-xs onay">
                        <label className="checkbox">
                          <span
                            className={`custom-checkbox ${
                              kvkk ? "selected" : ""
                            }`}
                          >
                            <input
                              type="checkbox"
                              className="onay"
                              id="IsKvkk"
                              name="IsKvkk"
                              onChange={() => setKvkk(!kvkk)}
                            />
                          </span>
                          <span className="Text">
                            <a href="kvkk.html" target="_blank">
                              KVKK metnini
                            </a>{" "}
                            Okudum Kabul Ediyorum.
                          </span>
                        </label>
                      </li>
                      <li className="col-xs-12">
                        <input
                          type="submit"
                          value="GÖNDER"
                          onClick={handleSubmit}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <!--/Title--> */}
            </div>
          </div>
          {/* <!--/page--> */}
          {/* <!--/page--> */}
        </div>
      </div>
    </div>
  );
}
